import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![moreHorizontalIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxIi8+PGNpcmNsZSBjeD0iMTkiIGN5PSIxMiIgcj0iMSIvPjxjaXJjbGUgY3g9IjUiIGN5PSIxMiIgcj0iMSIvPjwvc3ZnPg==) */
const moreHorizontalIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })]
});

export { moreHorizontalIcon };
